import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies } from 'react-cookie';
import Enums from '../../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargeCalculatorPartApp(props) {
    const [qCnts, setQCnts] = useState(5);
    const [quota, setQuota] = useState(100);
    const [gender, setGender] = useState(0);
    const [age, setAge] = useState(0);
    const [area, setArea] = useState(0);
    const [discount, setDiscount] = useState("");

    function onNumChange(e, callback) {
        e.stopPropagation();
        e.preventDefault();
        let tmp = parseInt(e.target.value);
        if (false == isNaN(tmp)) {
            callback(tmp);
        }
    }

    function onOpenCalculator(e) {
        e.stopPropagation();
        e.preventDefault();
        window.open('#/charge/calculator');
    }

    function onSubmit(e) {
        e.stopPropagation();
        e.preventDefault();
        // if (qCnts < 5) {
        //     alert("題數最少為5");
        //     setQCnts(5);
        // }

        let tmp = {
            max_people: quota,
            gender: gender,
            age: age,
            region: area,
            discount_code: discount
        };
        if (props.isShowQCunts) {
            tmp.question_number = qCnts;
        }
        props.onSubmit(tmp)
    }

    function onSaveAndBack(e) {
        e.stopPropagation();
        e.preventDefault();
        // if (qCnts < 5) {
        //     alert("題數最少為5");
        //     setQCnts(5);
        // }

        let tmp = {
            max_people: quota,
            gender: gender,
            age: age,
            region: area,
            discount_code: discount
        };
        if (props.isShowQCunts) {
            tmp.question_number = qCnts;
        }
        props.onSaveAndBack(tmp)
    }

    function onDeposit(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onDeposit");

        props.onDeposit();
    }

    function onQCntsChange(val) {
        setQCnts(val);
    }
    function onQCntsBlur() {
        if (qCnts < 5) {
            alert("題數最小為5題");
            setQCnts(5);
        }
    }

    function render() {
        let tmp = Enums.E_QUOTA;
        let checkDom = [];
        tmp.forEach((val, idx) => {
            checkDom.push(
                <Col sm={2} id={`quota-${val}`}>
                    <Form.Check type="radio" label={val} value={val} name="quota" checked={val == quota} onChange={() => { console.log(val); setQuota(val) }} />
                </Col>
            );
        });

        let genderDom = [];
        for (let key in Enums.E_GENDER_TEXT) {
            genderDom.push(
                <Col sm={0 == key ? "auto" : 2} id={`gender-${key}`}>
                    <Form.Check type="radio" label={Enums.E_GENDER_TEXT[key]} value={key} name="gender" checked={key == gender} onChange={() => { setGender(key) }} />
                </Col>
            );
        }

        let ageDom = [];
        for (let key in Enums.E_AGE_TEXT) {
            ageDom.push(
                <Col sm={"auto"} id={`age-${key}`}>
                    <Form.Check type="radio" label={Enums.E_AGE_TEXT[key]} value={key} name="age" checked={key == age} onChange={() => { setAge(key) }} />
                </Col>
            );
        }

        let areaDom = [];
        for (let key in Enums.E_AREA_TEXT) {
            areaDom.push(

                <Form.Group as={Row} className="" controlId="formPlaintextArea" id={`area-${key}`}>
                    <Form.Label column sm="1"></Form.Label>
                    <Col sm={10}>
                        <Form.Check inline type="radio" label={Enums.E_AREA_TEXT[key]} value={key} name="area" checked={key == area} onChange={() => { setArea(key) }} />
                        <small>{Enums.E_AREA_PS_TEXT[key]}</small>
                    </Col>
                </Form.Group>
            );
        }

        let resultDom = props.isEstimate ? (
            <Form.Group as={Row} className="mb-3" controlId="formPlaintextAge">
                <Form.Label column>
                    {props.result ? <strong className="ml-4 text-red text-120percent"><u>試算結果：{props.result}</u></strong> : null}
                </Form.Label>
                <Form.Label column xs="12" sm="4" className="text-right">
                    <Button variant="primary" className="mr-2" type="submit" onClick={onSubmit}>開始計算</Button>
                    <Button variant="primary" type="submit" onClick={onDeposit}>儲值去</Button>
                </Form.Label>
            </Form.Group>
        ) :
            (<>
                <Row>
                    <Col><Button variant="primary" type="submit" onClick={onOpenCalculator}>金額試算器</Button></Col>
                    <Col><Button variant="primary" type="submit" onClick={onSaveAndBack}>儲存<br />(回專案列表)</Button></Col>
                    <Col><Button variant="primary" type="submit" onClick={onSubmit}>設定完成，<br />付費去</Button></Col>
                </Row>
                {props.result ? <Row><strong className="ml-4 text-red text-120percent"><u>試算結果：{props.result}</u></strong></Row> : null}
            </>);

        return (
            <Form>
                {props.isShowQCunts ? (
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextQcnts">
                        <Form.Label column sm="2">
                            題數
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control type="number" value={qCnts} min={5} onChange={(e) => { onNumChange(e, onQCntsChange) }} onBlur={onQCntsBlur} />
                        </Col>
                    </Form.Group>
                ) : null}

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextQuota">
                    <Form.Label column sm="2">
                        調查份數
                    </Form.Label>
                    {checkDom}
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextGender">
                    <Form.Label column sm="2">
                        性別設定
                    </Form.Label>
                    {genderDom}
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextAge">
                    <Form.Label column sm="2">
                        年齡設定
                    </Form.Label>
                    {ageDom}
                </Form.Group>

                <Form.Group as={Row} className="" controlId="formPlaintextArea">
                    <Form.Label column sm="12">
                        地區設定
                    </Form.Label>
                </Form.Group>
                {areaDom}

                {props.isEstimate ? null : (<Form.Group as={Row} className="mb-3" controlId="formPlaintextAge">
                    <Form.Label column sm="2">
                        輸入優惠代碼
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control autoComplete="discount" name="hidden" type="text" value={discount} onChange={(e) => { setDiscount(e.target.value) }} placeholder="" />
                    </Col>
                </Form.Group>)}

                {resultDom}
            </Form >
        );
    }
    return render();
})